import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../view/pages/Home";
import Suppliers from "../view/pages/Suppliers";
import SuppliersList from "../view/pages/SuppliersList";
import Products from "../view/pages/Products";
import Login from "../view/pages/Login";
import Main from "../view/layouts/Main";
import ManageSuppliers from "../view/pages/admin/ManageSuppliers";
import ManageProducts from "../view/pages/admin/ManageProducts";
import Logs from "../view/pages/admin/Logs";
import VueRouterReferer from "@tozd/vue-router-referer";
import { ADMIN, SHAREHOLDER } from "../constants/user-groups";
import "../vue-msal.js";

Vue.use(VueRouter);
Vue.use(VueRouterReferer);

const router = new VueRouter({
  mode: "history",
  routes: [
    {
      name: "home",
      path: "/",
      component: Home
    },
    {
      name: "login",
      path: "/login",
      component: Login
    },
    {
      path: "/",
      component: Main,
      children: [
        {
          name: "suppliers",
          path: "/suppliers",
          component: Suppliers
        },
        {
          name: "specific.supplier",
          path: "/suppliers/:supplierId",
          component: Suppliers
        },
        {
          name: "suppliers.list",
          path: "/suppliers-list",
          component: SuppliersList
        },
        {
          name: "supplier.products",
          path: "/supplier/:supplierId/products",
          component: Products
        },
        {
          name: "manage.suppliers",
          path: "/manage/suppliers",
          component: ManageSuppliers
        },
        {
          name: "manage.products",
          path: "/manage/products",
          component: ManageProducts
        },
        {
          name: "logs",
          path: "/logs",
          component: Logs
        }
      ]
    }
  ]
});

// router.beforeEach((to, from, next) => {
//   return next();
// });

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js